import React, {useImperativeHandle, forwardRef, useEffect, useState, Fragment, useCallback} from "react";
import {Gallery} from "@models/gallery";
import ItemForm from '@components/video-contents/galleries/ItemForm';
import galleryApi from "@api/video-content";
import update from 'immutability-helper';

type GalleryStateShape = {
  selectedItems: Gallery[]; // it would be array of object
  deletedItems: string[]; //it would be array of id
  id: string | null;
};


export type GalleryRef = {
  value: GalleryStateShape
}

interface GalleryPropsShape {
  video_content_id?: string;
  isDuplicatedForm?:boolean;
}


function Gallery(props: GalleryPropsShape, ref) {
  const {video_content_id} = props;
  const [state, setState] = useState({
    selectedItems: [],
    deletedItems: []
  });
  
  useEffect(() => {
    if (video_content_id) {
      fetchGalleries()
    }
  }, []);
  
  const fetchGalleries = () => {
    galleryApi.getGalleryList({
        params: {
          id: video_content_id
        }
      })
      .then(({data}) => {
        // @ts-ignore
        setState({
          ...state,
          selectedItems: props.isDuplicatedForm
          ? data.map(({ video_content_id, ...rest }) => ({
          ...rest,
            id: null,
          }))
        : data,
        });
      })
      .catch((error) => {
        console.log(error)
      })
  }
  
  useImperativeHandle(ref, () => ({
    value: {
      ...state,
      selectedItems: state.selectedItems.map((item, index) => ({
        ...item,
        order: index
      }))
    }
  }));
  
  const onAdd = (newItem: Gallery) => {
    // Should i remove below line?
    newItem.order = newItem.order || state.selectedItems.length;
    // @ts-ignore
    setState({
      ...state,
      selectedItems: [...state.selectedItems, newItem]
    })
  };
  
  const onDelete = (index: number) => {
    // deleted items if has got it so should be added in the deletedItems Table and
    // BTW should omit from every Table (if id exist or not)
    const deletedGallery = state.selectedItems[index];
    if (deletedGallery.id) {
      // @ts-ignore
      setState({
        ...state,
        deletedItems: state.deletedItems.push(deletedGallery.id)
      })
    }
    setState({
      ...state,
      selectedItems: [...state.selectedItems.slice(0, index), ...state.selectedItems.slice(index + 1)]
    })
  };
  
  const onEdit = (updatedIndex, data) => {
    const cloneItems = Object.assign(state.selectedItems);
    cloneItems[updatedIndex] = data;
    // @ts-ignore
    setState({
      ...state,
      selectedItems: cloneItems
    });
  };
  
  const renderCard = (card: Gallery, index: number) => {
    return (
      <ItemForm
        key={card.id}
        index={index}
        id={index}
        item={card}
        moveCard={moveCard}
        onDelete={onDelete}
        onEdit={onEdit}
      />
    )
  }
  const moveCard = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      const dragCard = state.selectedItems[dragIndex]
      setState({
        ...state,
        selectedItems: update(state.selectedItems, {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]]
        })
      })
    },
    [state.selectedItems]
  )
  
  return (
    <Fragment>
      <ItemForm onAdd={data => onAdd(data)} key={`add-${state.selectedItems.length + 1}th-items`}/>
      <div style={{}}>{state.selectedItems.map((card, i) => renderCard(card, i))}</div>
    </Fragment>
  )
}

export default forwardRef(Gallery);
